import { amplifyProxy } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    unreconciledPayments: '',
    outGoingPayments: '',
    insights: '',
    income: '',
    portfolioGrowth: '',
    loading: {
      unreconciled: false,
      outgoing: false,
      insights: false,
      income: false,
      portfolio: false
    },
    error: {
      unreconciled: null,
      outgoing: null,
      insights: null,
      income: null,
      portfolio: null
    }
  },
  mutations: {
    SET_UNRECONCILED_PAYMENTS(state, data) {
      state.unreconciledPayments = data
    },
    SET_OUTGOING_PAYMENTS(state, data) {
      state.outGoingPayments = data
    },
    SET_INSIGHTS(state, data) {
      state.insights = data
    },
    SET_INCOME(state, data) {
      state.income = data
    },
    SET_PORTFOLIO_GROWTH(state, data) {
      state.portfolioGrowth = data
    },
    SET_LOADING(state, { type, value }) {
      state.loading[type] = value
    },
    SET_ERROR(state, { type, error }) {
      state.error[type] = error
    }
  },
  actions: {
    async getUnreconciledPayments({ commit, rootState }) {
      commit('SET_LOADING', { type: 'unreconciled', value: true })
      commit('SET_ERROR', { type: 'unreconciled', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/payments/unreconciled/count`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_UNRECONCILED_PAYMENTS', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', { type: 'unreconciled', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'unreconciled', value: false })
      }
    },

    async getOutGoingPayments({ commit, rootState }) {
      commit('SET_LOADING', { type: 'outgoing', value: true })
      commit('SET_ERROR', { type: 'outgoing', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/outgoingPayments/summary`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_OUTGOING_PAYMENTS', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', { type: 'outgoing', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'outgoing', value: false })
      }
    },

    async getInsights({ commit, rootState }) {
      commit('SET_LOADING', { type: 'insights', value: true })
      commit('SET_ERROR', { type: 'insights', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/dashboard/insights`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_INSIGHTS', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', { type: 'insights', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'insights', value: false })
      }
    },

    async getIncome({ commit, rootState }) {
      commit('SET_LOADING', { type: 'income', value: true })
      commit('SET_ERROR', { type: 'income', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/dashboard/income`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_INCOME', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', { type: 'income', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'income', value: false })
      }
    },

    async getPortfolioGrowth({ commit, rootState }) {
      commit('SET_LOADING', { type: 'portfolio', value: true })
      commit('SET_ERROR', { type: 'portfolio', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/dashboard/portfoliogrowth`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        // Maintain the specific .Nodes data structure from the response
        commit('SET_PORTFOLIO_GROWTH', response.data.Nodes)
        return response.data.Nodes
      } catch (error) {
        commit('SET_ERROR', { type: 'portfolio', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'portfolio', value: false })
      }
    }
  }
}